// actions
import { ROUTESUMMARY_HYDRATE } from './actions';

// TODO: eventually remove all values from initial state as this all comes from AEM
const RouteSummary = (
  state = {
    primaryGasSavingsLabel: 'Est. Gas Savings {TOTAL}',
    secondaryGasSavingsLabel:
      'Calculations based on a 5-day commute, round trip',
    perMonthLabel: '/mo',
    shortTripLabel: 'No supercharging needed',
    outOfRangeLabel: "We're working on getting you there",
    CTA: {},
  },
  action,
) => {
  switch (action.type) {
    case ROUTESUMMARY_HYDRATE:
      return {
        ...state,
        primaryGasSavingsLabel: action.data.primaryGasSavingsLabel,
        secondaryGasSavingsLabel: action.data.secondaryGasSavingsLabel,
        perMonthLabel: action.data.perMonthLabel,
        shortTripLabel: action.data.shortTripLabel,
        outOfRangeLabel: action.data.outOfRangeLabel,
        CTA: {
          ...action.data.CTA,
        },
      };
    default:
      return state;
  }
};

export default RouteSummary;
